<template>
  <div class="clothes-root relative mx-auto flex justify-center items-center">
    <img v-if="small" class="small" src="../../../assets/stamp/people-l.png" alt="People" />
    <template v-else>
      <img class="man" src="../../../assets/stamp/man.png" alt="Man" />
      <img class="woman" src="../../../assets/stamp/woman.png" alt="Woman" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Clothes',
  props: {
    small: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.clothes-root {
  max-width: 440px;
  @apply h-full;
  img {
    @apply mx-5;
    height: 100%;
    max-height: 440px;
  }
  .small {
    height: 250px;
  }
}
</style>
